import { render, staticRenderFns } from "./vir-editor.vue?vue&type=template&id=00579890&scoped=true"
import script from "./vir-editor.vue?vue&type=script&lang=js"
export * from "./vir-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00579890",
  null
  
)

export default component.exports